// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-03fd7659] .el-input-number--small{\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
